/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

export default ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
};
